export const projectCreation: any = [
  {
    isEmpty: true,
    title: "empty",
    description: "",
    icon: "add",
    type: "project_create",
  },
];

export function getApplicationDetails(basePath: string = '/') {
  return {
    id: "applications",
    name: "Applications",
    displayName: "Applications",
    // icon: "dashboard",
    assetIcon:`${basePath}assets/images/script/app-icon.svg`,
    order: 1,
    level: 0,
    type: "applications",
    // isAdd: true,
    view: "applicationOverviewView",
    addApplicationTemplate: [
      {
        name: "Application Name",
        dataType: "string",
        id: "name",
        placeholder: "Application Name",
      },
      {
        name: "Application Type",
        dataType: "type",
        id: "type",
        placeholder: "Application Type",
      },
      {
        name: "Environment",
        dataType: "browser",
        id: "browser",
        placeholder: "Environment",
      },
    ],
    children: [],
    active: true,
  };
}

export function getStandardTestSuitsDetails(basePath: string = '/') {
  return {
    id: "standardTestSuite",
    name: "Standard Test Suite",
    displayName: "Standard Test Suite",
    // icon: "rebase",
    assetIcon:`${basePath}assets/images/script/script-icon.svg`,
    order: 3,
    level: 0,
    type: "script_group",
    // isAdd: true,
    view: "standardTestSuiteView",
    children: [],
    addApplicationTemplate: [
      {
        id: 'type',
        key: "type",
        name: "Type",
        dataType: "radio",
        options: [
          { value: "test_suite", label: " Test Suite" },
          { value: "test_script", label: "Test Script" },
        ],
        customClass: "col-md-6",
        value: 'test_suite'
      },
      {
        id: 'test_suite_name',
        key: "test_suite_name",
        name: " Test Suite Name",
        dataType: "string",
        placeholder: " Test Suite Name",
        customClass: "mt-3",
        visibleIf: { key: "type", value: "test_suite" }
      },
      {
        id: 'test_script_name',
        key: "test_script_name",
        name: "Test Script Name",
        dataType: "string",
        placeholder: "Test Script Name",
        customClass: "mt-3",
        visibleIf: { key: "type", value: "test_script" }
      }
    ],
  };
}

export function getServicesDetails(basePath: string = '/') {
  return {
    id: "services",
    name: "Services",
    displayName: "Services",
    assetIcon:`${basePath}assets/images/script/script-icon.svg`,
    order: 4,
    level: 0,
    type: "api-service",
    view: "apiServiceView",
    children: [],
  };
}

export function getReusableComponentsDetails(basePath: string = '/') {
  return {
    id: "reusableComponents",
    name: "Reusable Components",
    displayName: "Reusable Components",
    // icon: "transition_dissolve",
    assetIcon:`${basePath}assets/images/script/reusable-icon.svg`,
    order: 2,
    level: 0,
    type: "reusable_component",
    // isAdd: true,
    view: "reusableComponentView",
    children: [],
    addApplicationTemplate: [
      {
        id: 'reusable_components_type',
        key: "type",
        name: "Reusable Components Type",
        dataType: "radio",
        options: [
          { value: "reusable_components_folder", label: "Component Folder" },
          { value: "reusable_component", label: "Reusable Component" },
        ],
        required: true,
        customClass: "col-md-6 hide-component",
        value: 'reusable_components_folder'
      },
      {
        id: 'folder_name',
        key: "folderName",
        name: "Reusable Components Folder Name",
        dataType: "string",
        placeholder: "Reusable Components Folder Name",
        required: false,
        // customClass: "mt-3",
        visibleIf: { key: "reusable_components_type", value: "reusable_components_folder" }
      },
      {
        id: 'component_name',
        key: "folderName",
        name: "Reusable Components Name",
        dataType: "string",
        placeholder: "Reusable Components Name",
        required: false,
        customClass: "mt-3 hide-component",
        visibleIf: { key: "reusable_components_type", value: "reusable_component" }
      }
    ],
    active: true,
  };
}

export const dataConnectionDetails = {
  id: "dataConnection",
  name: "Data Connections",
  displayName: "Data Connections",
  icon: "dashboard",
  order: 5,
  level: 0,
  type: "data_connection",
  // isAdd: true,
  view: "dataConnectionView",
  children: [],
  active: true,
};

export const initialProjectStructure = {
  id: "",
  name: "",
  displayName: "",
  order: 1,
  view: "automationProjectView",
  level: 0,
  type: "project",
  children: [
    getApplicationDetails(),
    getReusableComponentsDetails(),
    getStandardTestSuitsDetails(),
    getServicesDetails()
  ],
};

export const newProjectCreate: any = [
  {
    name: "Automation Project Name",
    dataType: "String",
    id: "name",
    placeholder: "Automation Project Name",
  },
  {
    name: "Automation Project Description",
    dataType: "String",
    id: "description",
    placeholder: "Automation Project Description",
  },
];

export const projectCardTile: any = {
  isEmpty: false,
  title: "",
  id: "",
  description: "",
  isContextMenu: true,
  contextMenuItems: ["Edit", "Delete"],
  icon: "folder_managed",
  type: "project_detail_view",
  editProjectTemplate: newProjectCreate
};

export const projectCardMoreDetails: any = [
  {
    ...getApplicationDetails(),
    isEmpty: false,
    title: "Applications",
    description: "",
    icon: "dashboard",
    type: "application_create",
    addApplicationTemplate: [
      {
        name: "Page Name",
        dataType: "string",
        id: "pageName",
        placeholder: "Page Name",
      },
      {
        name: "Page URL",
        dataType: "type",
        id: "url",
        placeholder: "Page URL",
      },
    ],
  },
  {
    ...getReusableComponentsDetails(),
    isEmpty: false,
    title: "Reusable Components",
    description: "",
    icon: "folder_managed",
    type: "reusable_component",
  },
  {
    ...getStandardTestSuitsDetails(),
    isEmpty: false,
    title: "Standard Test Suite",
    description: "",
    icon: "folder_managed",
    type: "script_group",
  },
  {
    ...getServicesDetails(),
    isEmpty: false,
    title: "Services",
    description: "",
    icon: "folder_managed",
    type: "api-services",
  }
];
